<template>
  <div class="picker">
    <van-field
      readonly
      clickable
      label=""
      :value="answer"
      :placeholder="question.tips || `请输入${question.label}`"
      @click="showPicker = true"
    />
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      >
        <div slot="columns-top">
          <van-search
            v-model="keyWord"
            show-action
            placeholder="请输入搜索关键词"
            @search="onSearch"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>
        <template v-slot:option="option">

          <div @click="onConfirm(option)">
            {{ option }}
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "picker",
  mixins: [mixins],
  data() {
    return {
      keyWord: "",
      showPicker: false,
      answer: "",
      first: true,
      columns: [],
    };
  },
  watch: {
    question: {
      handler(newVal) {
        console.log(newVal);
        if (newVal.default_value && this.first) {
          this.answer = newVal.default_value;
          this.change(newVal.default_value);
        }
        this.first = false;
      },
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.columns = [...this.question.optionList];
    },
    onConfirm(value) {
      this.answer = value;
      this.showPicker = false;
      this.answerChange(value);
    },
    onSearch() {
      const { question, keyWord } = this;
      const options = [...question.optionList];
      let result = [];
      if (!keyWord) {
        result = options;
      } else {
        options.forEach((option) => {
          if (option.indexOf(keyWord) !== -1) {
            result.push(option);
          }
        });
      }

      this.columns = result;
    },
    // change(value) {
    //   this.answerChange(value)
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>